/* eslint-disable react/react-in-jsx-scope */
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import {
  AuthLayout,
  ClientLayout,
  DefaultLayout,
  AdminLayout,
} from "../layouts";
import { useAuthContext, useLanguageContext } from "@/context";
import {
  allAuthFlattedRoutes,
  clientPublicFlattedRoutes,
  clientProtectedFlattedRoutes,
  allAdminFlattedRoutes,
  allBlankFlattedRoutes,
} from "./index";
import { useDispatch, useSelector } from "react-redux";
import { getAccessToken } from "../redux/authSlice";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AllRoutes = (props) => {
  const { session, isAuthenticated, removeSession } = useAuthContext();
  const { user, token } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fetchLoggedInUser = async () => {
    // ? check if current url is not /auth/login
    if (window.location.pathname !== "/auth/login") {
      if (isAuthenticated && session) {
        // ? check if user data and token is available in the store
        if (user && token) {
          return;
        } else {
          console.log("User data and token not available in the store");
          // ? if not, fetch the user data and token
          dispatch(getAccessToken(session?.refreshToken))
            .unwrap()
            .then((data) => {
              console.log("Connected user data fetched successfully: ");
            })
            .catch((error) => {
              // ? if there is an error, log the error and clear the session and token and redirect to login
              console.log("Error fetching connected user data: ", error);
              removeSession();
              navigate("/auth/login");
            });
        }
      }
    }
  };

  const { language } = useLanguageContext();
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  useEffect(() => {
    fetchLoggedInUser();
  }, []);

  return (
    <Routes>
      <Route>
        {allBlankFlattedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<DefaultLayout {...props}>{route.element}</DefaultLayout>}
          />
        ))}
      </Route>

      <Route>
        {allAuthFlattedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<AuthLayout {...props}>{route.element}</AuthLayout>}
          />
        ))}
      </Route>

      <Route>
        {clientPublicFlattedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<ClientLayout {...props}>{route.element}</ClientLayout>}
          />
        ))}
      </Route>

      <Route>
        {clientProtectedFlattedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              isAuthenticated && session?.role == "user" ? (
                <ClientLayout {...props}>{route.element}</ClientLayout>
              ) : (
                <Navigate
                  to={{
                    pathname: "/auth/login",
                    search: "redirectTo=" + route.path,
                  }}
                />
              )
            }
          />
        ))}
      </Route>

      <Route>
        {allAdminFlattedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              isAuthenticated && session?.role == "admin" ? (
                <AdminLayout {...props}>{route.element}</AdminLayout>
              ) : (
                <Navigate
                  to={{
                    pathname: "/auth/login",
                    search: "redirectTo=" + route.path,
                  }}
                />
              )
            }
          />
        ))}
      </Route>
    </Routes>
  );
};

export default AllRoutes;
